import { useMutation, useQueryClient } from "@tanstack/react-query";

import { approvePartnerMergeSuggestion, rejectPartnerMergeSuggestion } from "../../../../lib/api";

export function useClient360PartnerMerge(profileId: string) {
    const queryClient = useQueryClient();

    const invalidate = async () => {
        await Promise.all([
            queryClient.invalidateQueries({ queryKey: ["client-360-profile", profileId] }),
            queryClient.invalidateQueries({ queryKey: ["client-360-history", profileId] }),
        ]);
    };

    const approveMutation = useMutation({
        mutationFn: (suggestionId: number) => approvePartnerMergeSuggestion({ profileId, suggestionId }),
        onSuccess: invalidate,
    });

    const rejectMutation = useMutation({
        mutationFn: (suggestionId: number) => rejectPartnerMergeSuggestion({ profileId, suggestionId }),
        onSuccess: invalidate,
    });

    return {
        approve: async (suggestionId: number) => {
            await approveMutation.mutateAsync(suggestionId);
        },
        reject: async (suggestionId: number) => {
            await rejectMutation.mutateAsync(suggestionId);
        },
    };
}
